<template>
  <div class="pa-ovl" role="dialog" aria-modal="true" aria-labelledby="pa-booster-report-title" @click.self="$emit('close')">
    <!-- design pa-app.jsx deliverBooster / Modal: round link icon, muted body, URL box, confirm disabled until filled -->
    <div class="pa-cmodal">
      <div class="pa-cmodal__icon"><i class="material-icons" aria-hidden="true">link</i></div>
      <h3 id="pa-booster-report-title" class="pa-cmodal__title">{{ editing ? 'Edit report link (admin)' : 'Add report link (admin)' }}</h3>
      <p v-if="editing" class="pa-cmodal__body">
        Replace the report link for “{{ details }}”. The user sees the new link right away; the delivery date
        does not change.
      </p>
      <p v-else class="pa-cmodal__body">
        Paste the Google Drive / Docs link to the delivery report. Saving marks the booster as Delivered and the
        user sees the link right away.
      </p>
      <input
        ref="url"
        v-model="url"
        class="pa-in pa-cmodal__field"
        type="url"
        inputmode="url"
        placeholder="https://docs.google.com/..."
        :disabled="busy"
        @keydown.enter.prevent="submit"
      />
      <p v-if="showError" class="pa-err pa-cmodal__err">Enter the full URL, including https://</p>
      <div class="pa-cmodal__acts">
        <button type="button" class="pa-btn pa-btn--out" :disabled="busy" @click="$emit('close')">Cancel</button>
        <button
          type="button"
          class="pa-btn pa-btn--orange"
          :disabled="busy || !url.trim()"
          @click="submit"
        >{{ editing ? 'Save link' : 'Save link & mark delivered' }}</button>
      </div>
    </div>
  </div>
</template>

<script>
/** Admin: the Google Doc / Sheet delivery report of a booster order. Emits `confirm` with { reportUrl }. */
const URL_RE = /^https?:\/\/[^\s.]+\.[^\s]{2,}$/i

export default {
  name: 'PopAuthorityBoosterReportModal',
  props: {
    details: { type: String, default: '' },
    initialUrl: { type: String, default: '' },
    /** 'deliver' (marks the booster delivered) | 'edit' (replaces the link) */
    mode: { type: String, default: 'deliver' },
    busy: { type: Boolean, default: false },
  },
  data () {
    return {
      url: this.initialUrl || '',
      showError: false,
    }
  },
  computed: {
    editing () {
      return this.mode === 'edit'
    },
  },
  mounted () {
    this.$nextTick(() => {
      if (this.$refs.url) this.$refs.url.focus()
    })
  },
  watch: {
    url () {
      this.showError = false
    },
  },
  methods: {
    submit () {
      const raw = (this.url || '').trim()
      if (!raw || this.busy) return
      const withScheme = !/^https?:\/\//i.test(raw) ? `https://${raw}` : raw
      if (!URL_RE.test(withScheme)) {
        this.showError = true
        return
      }
      this.$emit('confirm', { reportUrl: withScheme })
    },
  },
}
</script>

<style lang="scss" scoped>
@import './setup/setup.scss';
@import './setup/designModal.scss';
</style>
